// ADD API URLS BELOW
export const API_URLS = {
    newsletterSignup: '/umbraco/api/newsletter/postform',
    searchSubmit: '/umbraco/api/search/redirect',
    // listings
    getArticles: '/umbraco/api/article/articles',
    getAuditDocuments: '/umbraco/api/audit/audit',
    getEvents: '/umbraco/api/event/events',
    getPublications: '/umbraco/api/publication/publication',
    getSearchResults: '/umbraco/api/search/search',
    getAiRegistrys: '/umbraco/api/airegistry/airegistry',
    // Typeaheads
    auditSearchTypeAhead: '/api/audit-typeahead',
    publicationsTypeAhead: '/api/publications-typeahead',
    searchTypeahead: '/umbraco/api/search/typeahead',
    AiRegistrysTypeAhead: '/umbraco/api/airegistry/airegistrytypeahead',
    // CSV
    getOrdersCSV: '/umbraco/api/airegistry/exportascsv',
};
